//@ts-ignore
export const IANA_TIMEZONES = Intl?.supportedValuesOf('timeZone') || []

export function convertTZ(date, tzString) {
  return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));   
}

export const getSystemTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone